<template>
    <new-autoselect
        name="category"
        placeholder="Select a topic"
        v-model="state.selectedCategory"
        :options="props.categories"
    ></new-autoselect>
</template>

<script setup>
import { defineProps, reactive } from "vue";

const props = defineProps({
    categories: {
        type: Array,
        required: true,
        default: [],
    },
    selectedCategory: {
        type: Number,
        default: null,
    },
});

const state = reactive({
    selectedCategory: props.selectedCategory,
});
</script>
